module.exports = __webpack_public_path__ + "img/zhny.feff3ec0.png";